export const INVALID_OTP = "INVALID_OTP";

export const OTP_ERROR_MESSAGES = {
  [INVALID_OTP]:
    "Invalid secure code. Please try again or choose No above to re-enter your mobile number.",
};
